export * from './pageApplet';
export { default } from './pageApplet';
